import { IMAGES, imgUrl } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export default function Intro() {
  return (
    <section id="intro" data-testid="intro-section" className="relative bg-sand py-24 lg:py-32">
      <span aria-hidden="true" className="pointer-events-none absolute right-6 top-14 select-none font-serif text-7xl text-atlantic/[0.06] sm:text-8xl lg:right-16">01</span>
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 lg:grid-cols-12 lg:gap-10 lg:px-8">
        <Reveal className="lg:col-span-6">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-ocean">The Atlantic, Reconsidered</p>
          <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-atlantic sm:text-4xl lg:text-[2.75rem]">
            Turning the Atlantic Into a Working Bridge
          </h2>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
            The Atlantic Ocean divided communities, carried forced migration and shaped centuries of political and
            economic history. Today, it can also become a bridge. Atlantic Bridge Institute examines the unfinished
            relationships between Africa and the Caribbean and identifies practical pathways for cooperation in
            governance, trade, health, climate resilience, education, culture and innovation.
          </p>
          <div className="mt-10 flex items-center gap-4" aria-hidden="true">
            <span className="h-px w-16 bg-gold" />
            <span className="h-2 w-2 rotate-45 border border-gold" />
            <span className="h-px w-16 bg-gold" />
          </div>
        </Reveal>
        <Reveal delay={0.15} className="relative lg:col-span-5 lg:col-start-8">
          <div className="absolute -left-4 -top-4 h-full w-full border border-gold/50" aria-hidden="true" />
          <img
            src={imgUrl(IMAGES.waves, 1000)}
            alt="Dark Atlantic ocean waves"
            loading="lazy"
            className="relative aspect-[4/5] w-full object-cover sm:aspect-[5/4] lg:aspect-[4/5]"
          />
          <p className="relative mt-4 text-xs italic text-slate-500">
            The Atlantic carried centuries of history — and the possibility of renewed connection.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
